<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="is-pulled-left">
          <h1 class="title">Review of Systems Masters</h1>
        </div>
        <div class="is-pulled-right">
          <button type="button" class="button is-primary" @click="addSymptom()">
            <i class="fa fa-plus"></i> Add System
          </button>
        </div>
      </div>
    </div>

    <div class="panel mb2" v-for="system in symptoms">
      <div class="panel-heading is-clearfix">
        <i
          class="fa fa-times pointer mr1 pull-right has-text-light"
          title="delete system"
          @click="symptomDelete(system)"
        ></i>
        <i
          class="fa fa-pencil pointer mr1 pull-right has-text-light"
          title="edit system"
          @click="editSymptom(system)"
        ></i>
        <i
          class="fa fa-plus pointer mr1 pull-right has-text-light"
          title="add symptom"
          @click="addSymptom(system.id)"
        ></i>

        {{ system.name }}
      </div>
      <div class="panel-block" v-for="symptom in system.symptoms">
        <i
          class="fa fa-times pointer mr1 pull-right has-text-light"
          title="delete symptom"
          @click="symptomDelete(symptom)"
        ></i>
        <i
          class="fa fa-pencil pointer mr1 pull-right has-text-light"
          title="edit symptom"
          @click="editSymptom(symptom)"
        ></i>
        {{ symptom.name }}
      </div>
    </div>

    <alert
      ref="alert"
      title="Confirm Delete"
      :onConfirm="onConfirm"
      :confirmLabel="deleteButton"
    >
      {{ deleteMessage }}
    </alert>

    <vue-toastr ref="toastr"></vue-toastr>

    <symptom-form
      :show="form.show"
      :title="form.title"
      :symptom="form.symptom"
      :label="form.label"
      :loading="form.loading"
      @hide="hideForm"
      :onSubmit="onSubmit"
    >
    </symptom-form>
  </div>
</template>

<script>
import alert from "@/components/alert";
import SymptomsService from "@/services/SymptomsService";
import SymptomForm from "./Form";

export default {
  name: "symptom-list",

  components: {
    SymptomForm,
    alert
  },

  data() {
    return {
      symptomId: null,
      deleteMessage: "",
      deleteButton: "",
      form: {
        loading: true,
        show: "",
        title: "",
        symptom: {},
        label: ""
      }
    };
  },

  // TODO ask Eric about alignment in panel-block

  computed: {
    symptoms() {
      return this.$store.getters["symptom/list"];
    }
  },

  methods: {
    addSymptom(system = null) {
      this.form = {
        show: true,
        title: system ? "Add A Symptom" : "Add A System",
        symptom: { system_id: system, name: "" },
        label: "Add"
      };
    },
    editSymptom(symptom) {
      this.form = {
        show: true,
        title: "Update",
        symptom,
        label: "Update"
      };
    },
    hideForm() {
      this.form.show = false;
    },
    onSubmit() {
      if (!this.form.symptom.id) {
        SymptomsService.create(this.form.symptom).then(() => {
          this.form.loading = false;
          this.form.show = false;
          SymptomsService.load();
        });
      } else {
        SymptomsService.update(this.form.symptom).then(() => {
          this.form.loading = false;
          this.form.show = false;
          SymptomsService.load();
        });
      }
    },
    symptomDelete(symptom) {
      this.$refs.alert.open();
      this.symptomId = symptom.id;
      if (symptom.systemId) {
        this.deleteMessage = "Are you sure you want to delete this symptom?";
        this.deleteButton = "Delete symptom";
      } else {
        this.deleteMessage =
          "Are you sure you want to delete this system and ALL of the symptoms under it?";
        this.deleteButton = "Delete system & symptoms";
      }
    },
    onConfirm() {
      SymptomsService.delete(this.symptomId)
        .then(() => {
          this.$refs.toastr.s("The symptom has been deleted.");
          this.interviewId = null;
          SymptomsService.load();
        })
        .catch(() => {
          this.$refs.toastr.e("There was an error deleting the symptom.");
          this.interviewId = null;
        });
    }
  },

  mounted() {
    SymptomsService.load();
  }
};
</script>

<style lang="scss">
.panel-block {
  display: block;
}
</style>
